export default __webpack_public_path__ + "static/media/14-shine.e7e74b5e.png";